import React, {useContext} from 'react';
import { Route, Navigate  } from 'react-router-dom';
import {UserDetailsContext} from "../Context/userDetailsContext";

const RedirectToHomeIfAuthenticated = ({ children }) => {
 const {userDetails} = useContext(UserDetailsContext);
    return userDetails.isAuthenticated ? <Navigate to="/" /> : children ;

};

export default RedirectToHomeIfAuthenticated;
